export default __webpack_public_path__ + "static/media/245.40934b6b.jpg";